import { Action } from "redux";
import { ISite } from "types";

export const SIGN_IN_ACTION = '@@user/SIGN_IN_ACTION';
export const SIGN_OUT_ACTION = '@@user/SIGN_OUT_ACTION';
export const SEND_PASSSWORD_ACTION = '@@user/SEND_PASSSWORD_ACTION';
export const CHANGE_PASSSWORD_ACTION = '@@user/CHANGE_PASSSWORD_ACTION';
export const LOST_PASSWORD_NAVIGATE_ACTION = '@@user/LOST_PASSWORD_NAVIGATE_ACTION';
export const RESGITER_NAVIGATE_ACTION = '@@user/RESGITER_NAVIGATE_ACTION';
export const RESGITER_ACTION = '@@user/RESGITER_ACTION';


export interface ISignInAction extends Action {
  type: string;
  error: boolean;
  errorMessage: string;
  payload?: {
    login: string;
    password: string;
    profile: string;
    rememberMe: boolean;
    sites: ISite[];
  };
}

export interface IRegisterAction extends Action {
  type: string;
  error: boolean;
  errorMessage: string;
}

export interface ISignOutAction extends Action {
  type: string;
  payload: {};
}

export interface ISendPasswordAction extends Action {
  type: string;
  error: boolean;
  errorMessage: string;
  payload: {};
}

export interface IChangePasswordAction extends Action {
  type: string;
  error: boolean;
  errorMessage: string;
  payload: {};
}

export interface IRegisterNavigateAction extends Action {
  type: string;
  payload: {};
}

export interface ILostPasswordNavigateAction extends Action {
  type: string;
  payload: {};
}


export interface IEditTemperatureNavigateAction extends Action {
  type: string;
  payload: { no: number };
}


export type AuthentificationActions = ISignInAction | ISignOutAction | IRegisterNavigateAction; 


// WEBPACK FOOTER //
// ./src/actions/AuthenticationActionType.tsx